import ResizeObserver from 'resize-observer-polyfill';
import { ref, onMounted, onBeforeUnmount } from 'vue-demi';
import { isElementInViewport } from '../util';
const {
    store: { cmp }
} = require('@futuweb/fego-render');
const { throttle } = require('@futuweb/fego-bridge');

export function useHeaderActive({ horizontalTabRef, props }, { onItemRenderChange }) {
    const current = ref(0);

    const setActive = (target) => {
        const idx = props.tpl.props.list.findIndex((item) => item.target === target);
        if (idx >= 0) {
            current.value = idx;
        }
    };

    const handleScroll = throttle(() => {
        const sections = props.tpl.props.list
            .map((item) => item.target)
            .filter((item) => item)
            .map((id) => cmp.getVmById(id, false))
            .filter((item) => item);
        let active = null;
        sections.forEach((section) => {
            if (!active && isElementInViewport(section?.$el, 'top')) {
                active = section;
            }
        });
        if (active) {
            setActive(active.tpl?.id);
        }
    }, 30);

    const watchScroll = () => {
        window.addEventListener('scroll', handleScroll);
    };

    const unWatchScroll = () => {
        window.removeEventListener('scroll', handleScroll);
    };

    let itemObserver = null;
    const observeItem = () => {
        const element = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-part');
        itemObserver = new ResizeObserver((entries) => {
            onItemRenderChange?.();
        });

        if (element) {
            itemObserver?.observe(element);
        }
    };

    const unobserveItem = () => {
        itemObserver?.disconnect();
    };

    onMounted(() => {
        watchScroll();
        observeItem();
        handleScroll();
    });

    onBeforeUnmount(() => {
        unWatchScroll();
        unobserveItem();
    });

    return {
        current
    };
}
